import { ThemeTokens } from '@acp/core-ui';
import {
    Box, Button, HStack, Spinner, Text,
} from '@chakra-ui/react';

export function PortfolioItem({
    agencyId,
    agencyName,
    isCurrentPortfolio = false,
    isSwitching,
    switchingAgencyId,
    onChangePortfolio,
    onCloseSwitchPortfolioPanel,
}: {
    agencyId: number;
    agencyName: string;
    isCurrentPortfolio?: boolean;
    isSwitching: boolean;
    switchingAgencyId: number | null;
    onChangePortfolio: (agencyId: number) => void;
    onCloseSwitchPortfolioPanel: () => void;
}) {
    return (
        <Button
            onClick={
                isCurrentPortfolio || isSwitching
                    ? onCloseSwitchPortfolioPanel
                    : () => onChangePortfolio(agencyId)
            }
            style={{
                textAlign: 'left',
                wordWrap: 'break-word',
                whiteSpace: 'normal',
                cursor: isSwitching ? 'default' : 'pointer',
            }}
            isDisabled={isSwitching}
            fontWeight={500}
            justifyContent="start"
            w="full"
            h="auto"
            p={6}
            mb={3}
            bg={isCurrentPortfolio ? 'secondary.500' : ThemeTokens.Defaults.bgColor}
            _hover={{ bg: isCurrentPortfolio ? 'secondary.600' : 'muted.50' }}
        >
            <Box w="full">
                <HStack justifyContent="space-between">
                    <Text py={1} color={isCurrentPortfolio ? 'white' : 'muted.700'}>
                        {agencyName}
                    </Text>
                    {isSwitching && switchingAgencyId === agencyId ? (
                        <Box>
                            <Spinner color="primary.500" />
                        </Box>
                    ) : null}
                </HStack>

                {isCurrentPortfolio ? (
                    <Text
                        color="muted.300"
                        fontSize="sm"
                        fontWeight={300}
                    >
                        Your current portfolio
                    </Text>
                ) : null}
            </Box>
        </Button>
    );
}
